"use client";

import { useEffect, useState } from "react";
import { readSession } from "@/lib/portal/session";
import { apiMyCourses } from "@/lib/portal/api";

/** Renders its children (an enquiry button) unless the signed-in student is already enrolled in this course. */
export function HideIfEnrolled({ courseId, children }: { courseId?: number | null; children: React.ReactNode }) {
  const [enrolled, setEnrolled] = useState(false);

  useEffect(() => {
    const session = readSession();
    if (!session || session.role !== "student" || !courseId) return;
    let cancelled = false;
    apiMyCourses(session.token)
      .then((list) => !cancelled && setEnrolled(list.some((c) => c.course.id === courseId)))
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [courseId]);

  return enrolled ? null : <>{children}</>;
}
